/**
 * Pass as `paystubSnapshotRevisionID` when generating a paystub from the
 * stored snapshot baseline without applying any revisions.
 *
 * Snapshot revision IDs are UUIDs, so this reserved word cannot collide.
 */
export const PAYSTUB_SNAPSHOT_SELECTOR_BASELINE = "baseline" as const;
